import { Keypair } from 'tokend-js-sdk'
import { RequestRecord } from './request.record'
import config from '@conf'
import _get from 'lodash/get'
import { DocumentContainer } from '@js/helpers/DocumentContainer'

export class SaleRequestRecord extends RequestRecord {
  constructor (record = {details: {sale: {}}}) {
    super(record)
    this._details = record.details['sale']
    this.baseAsset = this._details.base_asset || ''
    this.baseAssetForHardCap = this._details.base_asset_for_hard_cap || ''
    this.defaultQuoteAsset = this._details.default_quote_asset || config.DEFAULT_QUOTE_ASSET
    this.enableTimeSpec = this._details.enable_time_spec || false
    this.startTime = this._details.start_time || ''
    this.startTimeNow = this._details.start_time_now || false
    this.endTime = this._details.end_time || ''
    this.softCap = this._details.soft_cap || ''
    this.hardCap = this._details.hard_cap || ''
    this.quoteAssets = (this._details.quote_assets || []).map(item => item.asset ? item.asset : item.quote_asset) // from local storage we get asset, from back - quote_asset
    this.name = _get(this._details, 'details.name') || ''
    this.internal_type = _get(this._details, 'details.internal_type') || ''
    this.payments_frequency = _get(this._details, 'details.payments_frequency') || config.SALE_PERIOD_VARIANTS[0]
    this.annual_percentage = _get(this._details, 'details.annual_percentage') || ''
    this.loan_term = _get(this._details, 'details.loan_term') || config.SALE_PERIOD_VARIANTS[0]
    this.financial_frequency = _get(this._details, 'details.financial_frequency') || config.SALE_PERIOD_VARIANTS[0]
    this.profitability_from = _get(this._details, 'details.profitability_from') || ''
    this.profitability_to = _get(this._details, 'details.profitability_to') || ''
    this.min_invest_amount = _get(this._details, 'details.min_invest_amount') ? _get(this._details, 'details.min_invest_amount') : null
    this.min_term = _get(this._details, 'details.min_term') || ''
    this.term = _get(this._details, 'details.term') || ''
    this.description = _get(this._details, 'details.description') || ''
    this.descriptionID = _get(this._details, 'details.description') || ''
    this.shortDescription = _get(this._details, 'details.short_description') || ''
    this.youtubeId = _get(this._details, 'details.youtube_video_id') || ''
    this.videoDescriptionArray = _get(this._details, 'details.video_description_array') || []
    this.logo = _get(this._details, 'details.logo') ? new DocumentContainer(_get(this._details, 'details.logo')) : null
    this.logoUrl = this._getLogoUrl() || ''
    this.investorIncome = _get(this._details, 'details.investor_income') || ''
    this.token = _get(this._details, 'details.token') || ''

    this.saleIndex = this._getIndex()
    this.steps = this._details.steps || {
      step_1: false,
      step_2: false,
      step_3: false,
      step_4: false,
      step_5: false
    }
  }

  _getIndex () {
    return Keypair.random().accountId()
  }

  _getLogoUrl () {
    const key = _get(this._details, 'details.logo.key')
    if (!key) return ''
    return `${config.FILE_STORAGE}/${key}`
  }

  getDetailsForSave () {
    return {
      details: {
        sale: {
          request_id: this.id,
          base_asset: this.baseAsset,
          base_asset_for_hard_cap: this.baseAssetForHardCap,
          default_quote_asset: this.defaultQuoteAsset,
          enable_time_spec: this.enableTimeSpec,
          start_time: this.startTime,
          start_time_now: this.startTimeNow,
          end_time: this.endTime,
          soft_cap: this.softCap,
          hard_cap: this.hardCap,
          quote_assets: this.quoteAssets.filter(i => i).map((item) => ({
            asset: item,
            price: '1'
          })),
          details: {
            name: this.name,
            internal_type: this.internal_type,
            annual_percentage: this.annual_percentage,
            payments_frequency: this.payments_frequency,
            loan_term: this.loan_term,
            financial_frequency: this.financial_frequency,
            profitability_from: this.profitability_from,
            profitability_to: this.profitability_to,
            min_invest_amount: this.min_invest_amount,
            term: this.term,
            min_term: this.min_term,
            description: this.descriptionID,
            descriptionID: this.descriptionID,
            short_description: this.shortDescription,
            youtube_video_id: this.youtubeId,
            video_description_array: this.videoDescriptionArray,
            logo: this.logo ? (this.logo).getDetailsForSave() : null,
            investor_income: this.investorIncome,
            token: this.token
          },
          logoUrl: this.logoUrl,
          saleIndex: this.saleIndex,
          steps: this.steps
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/records/sale_request.record.js